import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Chip,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { LocalOffer as LocalOfferIcon } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../../services/api";

const useStyles = makeStyles((theme) => ({
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 650,
  },
  emptyState: {
    padding: theme.spacing(3),
    textAlign: "center",
  },
  statusChip: {
    fontWeight: 600,
  },
}));

const formatCurrency = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return "-";
  }

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(Number(value));
};

const ClienteNegociacoes = ({ clienteId }) => {
  const classes = useStyles();
  const history = useHistory();
  const [negociacoes, setNegociacoes] = useState([]);
  const [loading, setLoading] = useState(false);

  const hasNegociacoes = useMemo(() => negociacoes.length > 0, [negociacoes]);

  useEffect(() => {
    let isMounted = true;

    const loadNegociacoes = async () => {
      setLoading(true);
      try {
        const { data } = await api.get(`/kanban/cards/cliente/${clienteId}`);
        if (isMounted) {
          setNegociacoes(Array.isArray(data) ? data : []);
        }
      } catch (error) {
        console.error("Erro ao carregar negociações do cliente:", error);
        toast.error("Erro ao carregar negociações");
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    if (clienteId) {
      loadNegociacoes();
    }

    return () => {
      isMounted = false;
    };
  }, [clienteId]);

  return (
    <Box>
      <Box className={classes.header}>
        <Typography variant="h6">
          <LocalOfferIcon style={{ verticalAlign: "middle", marginRight: 8 }} />
          Negociações
        </Typography>
      </Box>

      {loading ? (
        <Box className={classes.emptyState}>
          <CircularProgress size={28} />
        </Box>
      ) : (
        <Paper>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Título</TableCell>
                <TableCell>Status / Fluxo</TableCell>
                <TableCell>Board</TableCell>
                <TableCell>Responsável</TableCell>
                <TableCell align="right">Valor</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!hasNegociacoes ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    Nenhuma negociação vinculada a este cliente
                  </TableCell>
                </TableRow>
              ) : (
                negociacoes.map((negociacao) => (
                  <TableRow
                    key={negociacao.id}
                    hover
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      history.push(
                        `/kanban-board?boardId=${negociacao.boardId}&columnId=${negociacao.columnId}&cardId=${negociacao.id}`
                      )
                    }
                  >
                    <TableCell>{negociacao.title || "-"}</TableCell>
                    <TableCell>
                      <Chip
                        label={negociacao.statusFluxo || "-"}
                        size="small"
                        color="primary"
                        variant="outlined"
                        className={classes.statusChip}
                      />
                    </TableCell>
                    <TableCell>{negociacao.boardName || "-"}</TableCell>
                    <TableCell>{negociacao.assignedUserName || "-"}</TableCell>
                    <TableCell align="right">{formatCurrency(negociacao.valor)}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </Paper>
      )}
    </Box>
  );
};

export default ClienteNegociacoes;
